import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { AUTH_LOGOUT_ERROR, AUTH_LOGOUT_REQUEST, AUTH_LOGOUT_SUCCESS } from '../types';
import { forgetCart } from '../cart/forget-cart';
import { clearSession } from './clear-session';
export var logoutRequest = function logoutRequest() {
  return {
    type: AUTH_LOGOUT_REQUEST
  };
};
export var logoutSuccess = function logoutSuccess(payload) {
  return {
    type: AUTH_LOGOUT_SUCCESS,
    payload: payload
  };
};
export var logoutError = function logoutError(error) {
  return {
    type: AUTH_LOGOUT_ERROR,
    error: true,
    payload: {
      error: error
    }
  };
};
export var logout = function logout() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, _getState, _ref) {
      var auth, metadata;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            auth = _ref.auth;
            _context.prev = 1;
            dispatch(logoutRequest());
            _context.next = 5;
            return auth.getUser();
          case 5:
            metadata = _context.sent;
            _context.next = 8;
            return auth.logout();
          case 8:
            _context.next = 10;
            return dispatch(logoutSuccess({
              email: metadata.email
            }));
          case 10:
            _context.next = 12;
            return dispatch(forgetCart());
          case 12:
            _context.next = 14;
            return dispatch(clearSession());
          case 14:
            _context.next = 20;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](1);
            dispatch(logoutError(_context.t0));
            throw _context.t0;
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 16]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};